export default "__VITE_ASSET__CAA$kuzp__"